import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  selectTag: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 290
  },
  select: {
    maxWidth: 390,
    width: '100%'
  },
  totalCapacity: {
    paddingInline: 8,
    borderBottom: `1px solid ${token.black.black3}`
  },
  entries: {
    paddingInline: 8
  },
  capacity: {
    padding: '6px 12px'
  },
  wrapper: {
    width: 240,
    backgroundColor: token.colorBgSpotlight,
    borderRadius: 8,
    overflow: 'hidden'
  },
  textBlock: {
    paddingBlock: 6
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: 26,
    color: token.colorWhite
  }
}))
